import {Component} from '@angular/core';
import {ModalController} from '@ionic/angular';

@Component({
  selector: 'app-detect-location',
  templateUrl: './detect-location.component.html',
  styleUrls: ['./detect-location.component.scss']
})

export class DetectLocationComponent {
  constructor(private modalController: ModalController) {
  }

  dismiss() {
    this.modalController.dismiss();
  }
}
